import { ImHome, ImUser, ImFileText, ImDrawer, ImFilesEmpty } from 'react-icons/im';
import { AiFillAccountBook, AiFillAlert, AiFillFire, AiFillFunnelPlot, AiOutlineCluster } from 'react-icons/ai';
import {
  BsHouseLockFill, BsFillFileSpreadsheetFill, BsCalendar3, BsFillLayersFill, BsFillFileMedicalFill,
  BsArrowBarRight, BsFillOpticalAudioFill, BsCarFrontFill, BsSignpostSplitFill, BsJournalText
} from "react-icons/bs";
import {
  MdSubscriptions, MdOutlineStart, MdDashboard, MdPayments, MdSpaceDashboard, MdAccountBalanceWallet, MdOutlineDatasetLinked, MdDirectionsWalk,
  MdOutlineChecklist, MdAutoGraph, MdFactory, MdOtherHouses, MdOutlineElectricBolt, MdAlternateEmail, MdOutlinePrecisionManufacturing,
  MdSignpost, MdEditDocument
} from "react-icons/md";
import {
  FaMoneyBillWaveAlt, FaMoneyBillWave, FaLayerGroup, FaObjectUngroup, FaPercent, FaBookMedical, FaNotesMedical, FaUser, FaFileMedicalAlt, FaBaby,
  FaBusAlt, FaMotorcycle, FaWarehouse, FaDumpsterFire, FaPlane, FaPaperPlane
} from "react-icons/fa";
import {
  FaPeopleRoof, FaUsersRectangle, FaClipboardList, FaUsersLine, FaRectangleList, FaReceipt, FaTable, FaHouse, FaHandHoldingMedical, FaHouseMedical, FaPeopleGroup,
  FaTruckFast, FaPersonRays, FaGun
} from "react-icons/fa6";
import {
  PiListPlusFill, PiListNumbersFill, PiStrategyBold, PiBankBold, PiListBulletsFill, PiPlantFill, PiHouseSimpleFill, PiHouseFill,
  PiListChecksFill, PiSignatureBold, PiStickerFill
} from "react-icons/pi";
import { TiThList } from "react-icons/ti";
import { HiClipboardDocumentList, HiDocumentDuplicate, HiUserGroup, HiBellAlert } from "react-icons/hi2";
import { TbLayersSubtract, TbListNumbers, TbHttpPost, TbCategoryFilled, TbTextScan2 } from "react-icons/tb";
import { LuGroup, LuGaugeCircle, LuSettings } from "react-icons/lu";
import { SiWebmoney, SiOpenlayers, SiHiveBlockchain, SiGunicorn, SiMailgun, SiMarketo, SiGoogleanalytics } from "react-icons/si";
import { BiSolidLayer, BiSolidReport, BiSolidShip, BiStats, BiTransferAlt, BiSolidCertification, BiDice6 } from "react-icons/bi";
import { IoDocumentText, IoAnalyticsSharp, IoChatbubbles, IoShieldCheckmark, IoLocationSharp } from "react-icons/io5";
import { VscListTree } from "react-icons/vsc";
import { GoPackage } from "react-icons/go";
import { RiMediumFill, RiMentalHealthFill, RiSurgicalMaskFill, RiListCheck3, RiShip2Fill, RiQuoteText, RiListSettingsLine, RiTyphoonLine } from "react-icons/ri";
import { IoIosListBox, IoMdAnalytics, IoIosChatbubbles } from "react-icons/io";
import { GiPadlock, GiCrackedGlass, GiCheckMark, GiCoffin } from "react-icons/gi";
import { GrMoney } from "react-icons/gr";
import { CgNotifications, CgFileDocument } from "react-icons/cg";
import { LiaFileContractSolid } from "react-icons/lia";

// Define a map of icons
export const qilloIconMap = {
  ImHome,
  ImUser,
  ImDrawer,
  ImFileText,
  ImFilesEmpty,
  AiFillFire,
  AiFillAccountBook,
  AiFillAlert,
  BsHouseLockFill,
  BsFillFileSpreadsheetFill,
  BsCalendar3,
  BsFillOpticalAudioFill,
  BsSignpostSplitFill,
  BsJournalText,
  CgNotifications,
  CgFileDocument,
  FaMoneyBillWaveAlt,
  FaMoneyBillWave,
  FaPeopleRoof,
  FaUsersRectangle,
  FaClipboardList,
  FaUsersLine,
  FaRectangleList,
  FaLayerGroup,
  FaObjectUngroup,
  FaPercent,
  FaReceipt,
  FaTable,
  FaHouse,
  FaNotesMedical,
  FaUser,
  FaHandHoldingMedical,
  FaHouseMedical,
  FaFileMedicalAlt,
  FaBaby,
  FaPeopleGroup,
  FaBusAlt,
  FaPlane,
  FaGun,
  FaPaperPlane,
  FaMotorcycle,
  FaWarehouse,
  FaTruckFast,
  FaPersonRays,
  FaDumpsterFire,
  PiListPlusFill,
  PiListNumbersFill,
  PiStrategyBold,
  PiHouseSimpleFill,
  PiHouseFill,
  PiListChecksFill,
  PiSignatureBold,
  PiStickerFill,
  PiBankBold,
  PiListBulletsFill,
  PiPlantFill,
  TiThList,
  HiClipboardDocumentList,
  TbLayersSubtract,
  TbListNumbers,
  TbHttpPost,
  TbCategoryFilled,
  TbTextScan2,
  SiWebmoney,
  SiOpenlayers,
  SiGunicorn,
  SiMailgun,
  SiMarketo,
  SiGoogleanalytics,
  MdOtherHouses,
  MdOutlineElectricBolt,
  MdAlternateEmail,
  MdSpaceDashboard,
  MdAccountBalanceWallet,
  MdOutlineDatasetLinked,
  MdDirectionsWalk,
  MdSubscriptions,
  MdOutlineStart,
  MdDashboard,
  MdPayments,
  MdOutlineChecklist,
  MdAutoGraph,
  MdFactory,
  MdSignpost,
  MdOutlinePrecisionManufacturing,
  MdEditDocument,
  BiSolidLayer,
  BsFillLayersFill,
  BsCarFrontFill,
  LuGroup,
  LuGaugeCircle,
  LuSettings,
  IoDocumentText,
  IoAnalyticsSharp,
  FaBookMedical,
  BsFillFileMedicalFill,
  BsArrowBarRight,
  BiSolidReport,
  BiStats,
  BiTransferAlt,
  BiSolidCertification,
  BiDice6,
  HiDocumentDuplicate,
  HiUserGroup,
  HiBellAlert,
  VscListTree,
  GoPackage,
  GiCoffin,
  RiMediumFill,
  RiMentalHealthFill,
  RiSurgicalMaskFill,
  RiListCheck3,
  RiShip2Fill,
  RiQuoteText,
  RiListSettingsLine,
  RiTyphoonLine,
  BiSolidShip,
  SiHiveBlockchain,
  IoIosListBox,
  IoMdAnalytics,
  AiFillFunnelPlot,
  AiOutlineCluster,
  GiPadlock,
  GiCrackedGlass,
  GiCheckMark,
  IoChatbubbles,
  IoShieldCheckmark,
  IoLocationSharp,
  IoIosChatbubbles,
  GrMoney,
  LiaFileContractSolid
};


// Convert icons into react-select options
export const qilloIconOptions = Object.entries(qilloIconMap).map(([key, IconComponent]) => ({
  value: key,
  label: key,
  icon: <IconComponent size={20} />,
}));
